import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['item'];

  initialize() {
    window.console.log('Sortable Cocoon Controller Initialized!');
  }

  connect() {
    const handle = this.element.dataset.sortableCocoonHandle || '[name=sort_handle]';
    const sortableEl = this.element;

    $(this.element).sortable({
      axis: 'y',
      handle,
      tolerance: 'pointer',
      items: '> [data-target="sortable-cocoon.item"]',
      cursor: 'move',
      stop: () => {
        $.each(this.itemTargets, (i, item) => {
          // Only update .position inputs that belong to THIS sortable level —
          // not ones inside a nested sortable-cocoon container.
          $(item).find('.position').each((_, posEl) => {
            const closest = $(posEl).parents('[data-controller~="sortable-cocoon"]').first()[0];
            if (closest === sortableEl) {
              $(posEl).val(i);
            }
          });
        });
      },
    });
  }
}
